<template>
  <b-row align-v="center" class="pagenation">
    <b-col class="text-right" sm="3" v-if="isDetail">
      <b-nav>
        <b-nav-item @click="showList()"><b-icon icon="arrow-left-square"></b-icon>&nbsp;一覧に戻る</b-nav-item>
      </b-nav>
    </b-col>
    <!-- pager -->
    <b-col class="text-center" cols="12" :sm="isDetail ? 6 :12">
      <b-nav align="center">
        <b-nav-item :disabled="isNotFirst()" @click="showOther(0)">
          <SHIcons name="arrow-left-double" :iconColor="iconColor(isNotFirst())" width="32" height="32"/>
        </b-nav-item>
        <b-nav-item :disabled="isNotFirst()" @click="showOther(index - 1)">
          <SHIcons name="arrow-left-single" :iconColor="iconColor(isNotFirst())" width="32" height="32"/>
        </b-nav-item>
        <b-nav-item :disabled="isNotLast()" @click="showOther(index + 1)">
          <SHIcons name="arrow-right-single" :iconColor="iconColor(isNotLast())" width="32" height="32"/>
        </b-nav-item>
        <b-nav-item :disabled="isNotLast()" @click="showOther(total - 1)">
          <SHIcons name="arrow-right-double" :iconColor="iconColor(isNotLast())" width="32" height="32"/>
        </b-nav-item>
      </b-nav>
    </b-col>
    <!-- buttons -->
    <b-col class="text-right" sm="3" v-if="isDetail">
      <slot></slot>
    </b-col>
  </b-row>
</template>

<script>
import SHIcons from '@/components/ico/SHIcons.vue'

export default {
  name: 'Pagenation',
  components: {
    SHIcons
  },
  props: {
    index: Number,
    total: Number,
    isDetail: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isNotLast () {
      return this.total - 1 === this.index
    },
    isNotFirst () {
      return this.index === 0
    },
    iconColor (disabled) {
      return disabled ? '#999999' : '#33537E'
    },
    editClicked: function () {
      this.$emit('editClicked')
    },
    stopClicked: function () {
      this.$emit('stopClicked')
    },
    deleteClicked: function () {
      this.$emit('deleteClicked')
    },
    showOther: function (e) {
      this.$emit('showOther', e)
    },
    showList: function () {
      this.$emit('showList')
    }
  }
}
</script>

<style scoped>
.pagenation {
  margin-bottom: 6px;
}
</style>
